import React from 'react';
import GridList from '../gridList/GridList';

// `marginBottom` leaves room under a grid that ends the page, so a picker
// opened on its last row has somewhere to drop down to.
const CardViewFormGrid = ({ section, useStore, options }) => {
    return (
        <div style={section.meta.marginBottom ? { marginBottom: section.meta.marginBottom } : undefined}>
            <GridList type={section.meta.gridConfig} useStore={useStore} options={options} />
        </div>
    );
};

export default CardViewFormGrid;
